import { GET_IMAGE_BY_ID } from './webserviceById'
import { GET_IMAGES_BY } from './webservice'
export const ImagesWs = {
    GET_IMAGE_BY_ID,
    GET_IMAGES_BY
}